import { Manage } from '@core/ui';
import { Link } from '@online-webinar/router';
import { useTranslation } from 'react-i18next';

export const ManageEnvironmentButton = () => {
    const { t } = useTranslation();

    return (
        <div className="relative w-full h-14 mb-4 flex-none">
            <Link
                to="/manage"
                className="group absolute top-0 left-0 w-full menu:w-14 menu:hover:w-60 menu:focus-visible:w-60 2xl:hover:w-64 2xl:focus-visible:w-64 h-full bg-gray-300 flex items-center overflow-hidden p-3 rounded-xl text-primary transition-all duration-200 nav-link"
            >
                <Manage classNames="h-6 w-6 flex-none stroke-current ml-1 menu:opacity-50 menu:group-hover:opacity-100" />
                <span className="font-medium ml-2 menu:opacity-0 menu:group-hover:opacity-100 menu:group-focus-visible:opacity-100 whitespace-nowrap transition-opacity duration-200">
                    {t('MainMenu.ManageEnv')}
                </span>
            </Link>
        </div>
    );
};
